

// import React, { useState, useRef } from "react";

// import Icon from "../../assets/icons/Icon";
// import { FaTimes } from "react-icons/fa";

// const ImageUpload = ({ onImagedelete, onImageChange, imageData, title, isMultiple = false }) => {
//   const [previews, setPreviews] = useState(imageData ? [imageData] : []);
//   const [fileInfos, setFileInfos] = useState([]);
//   const [isDragging, setIsDragging] = useState(false);
//   const fileInputRef = useRef(null);

//   const handleFileInputChange = (e) => {
//     const files = e.target.files;
//     handleFiles(files);
//   };

//   const handleFiles = (files) => {
//     if (files && files.length > 0) {
//       const newFileInfos = [];
//       const newPreviews = [];

//       Array.from(files).forEach((file) => {
//         if (file.type.startsWith("image/")) {
//           newFileInfos.push({ name: file.name, size: file.size });
//           readAndPreviewFile(file, newPreviews);
//         }
//       });

//       setFileInfos((prev) => [...prev, ...newFileInfos]);
//       setPreviews((prev) => [...prev, ...newPreviews]);
//     }
//   };

//   const readAndPreviewFile = (file, newPreviews) => {
//     const reader = new FileReader();
//     reader.onloadend = () => {
//       newPreviews.push(reader.result);
//       setPreviews(newPreviews);
//       onImageChange && onImageChange(file);
//     };
//     reader.readAsDataURL(file);
//   };

//   const handleClick = () => {
//     fileInputRef.current.click();
//   };

//   const handleDragOver = (e) => {
//     e.preventDefault();
//     setIsDragging(true);
//   };

//   const handleDragLeave = (e) => {
//     e.preventDefault();
//     setIsDragging(false);
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     setIsDragging(false);
//     const files = e.dataTransfer.files;
//     handleFiles(files);
//   };

//   const handleDelete = (index) => {
//     const newPreviews = [...previews];
//     const newFileInfos = [...fileInfos];
//     newPreviews.splice(index, 1);
//     newFileInfos.splice(index, 1);
//     setPreviews(newPreviews);
//     setFileInfos(newFileInfos);
//     onImagedelete && onImagedelete(null);
//     if (fileInputRef.current) {
//       fileInputRef.current.value = "";
//     }
//   };

//   const formatFileSize = (size) => {
//     if (!size) return "";
//     return (size / 1024).toFixed(2) + " KB";
//   };

//   return (
//     <div className="flex flex-col gap-1">
//       <p
//         style={{ fontFamily: 'Inter,Source Sans Pro, Helvetica, Arial, sans-serif' }}
//         className="mb-1 text-[#000000]"
//       >
//         {title}
//       </p>

//       {previews.length > 0 ? (
//         <div className="space-y-2">
//           {previews.map((preview, index) => (
//             <div
//               key={index}
//               className="relative inline-block transition-transform duration-300 ease-in-out hover:scale-[1.02] border border-[#d7d5e2] shadow"
//             >
//               <img
//                 src={preview}
//                 alt="preview"
//                 className="h-[200px] w-[200px] object-cover"
//               />
//               <button
//                 onClick={() => handleDelete(index)}
//                 className="absolute right-1 bottom-1 bg-red-500 text-white rounded-full p-1 cursor-pointer  "
//               >
//                 <FaTimes className="h-3 w-3" />
//               </button>
//             </div>
//           ))}
//         </div>
//       ) : null}

//       {(isMultiple || previews.length === 0) && (
//         <div
//           className={`w-[200px] h-[200px] border-2 border-dashed ${isDragging ? "border-blue-500" : "border-[#d7d5e2]"
//             } cursor-pointer overflow-hidden`}
//           onClick={handleClick}
//           onDragOver={handleDragOver}
//           onDragLeave={handleDragLeave}
//           onDrop={handleDrop}
//         >
//           <input
//             type="file"
//             accept="image/*"
//             ref={fileInputRef}
//             onChange={handleFileInputChange}
//             className="hidden"
//             multiple={isMultiple}
//           />
//           <div className="pt-1 pl-1 pr-3">
//             Try dropping some files here, or click to select files to upload.
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ImageUpload;


import React, { useState, useRef, useEffect } from "react";
import { FaTimes } from "react-icons/fa";

const ImageUpload = ({ 
  onImagedelete, 
  onImageChange, 
  imageData, 
  title, 
  isMultiple = false,
  onFileInfoChange // New prop to pass file info to parent
}) => {
  const [previews, setPreviews] = useState(imageData ? [imageData] : []);
  const [fileInfos, setFileInfos] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  
  // Initialize with imageData if provided
  useEffect(() => {
    if (imageData) {
      setPreviews([imageData]);
    } else {
      setPreviews([]);
    }
  }, [imageData]);
  // Notify parent when fileInfos changes
  useEffect(() => {
    if (onFileInfoChange && fileInfos.length > 0) {
      onFileInfoChange(fileInfos[0]); // Send the first file info (assuming single upload)
    }
  }, [fileInfos, onFileInfoChange]);

  const handleFileInputChange = (e) => {
    const files = e.target.files;
    handleFiles(files);
  };

  const handleFiles = (files) => {
    if (files && files.length > 0) {
      const newFileInfos = [];
      const newPreviews = [];

      Array.from(files).forEach((file) => {
        if (file.type.startsWith("image/")) {
          newFileInfos.push({ 
            name: file.name, 
            size: file.size,
            type: file.type
          });
          readAndPreviewFile(file, newPreviews);
        }
      });

      setFileInfos(newFileInfos); // Replace rather than append for single upload
      setPreviews(newPreviews);
    }
  };

  const readAndPreviewFile = (file, newPreviews) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      newPreviews.push(reader.result);
      setPreviews(newPreviews);
      onImageChange && onImageChange(file);
    };
    reader.readAsDataURL(file);
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    handleFiles(files);
  };

  const handleDelete = (index) => {
    const newPreviews = [...previews];
    const newFileInfos = [...fileInfos];
    newPreviews.splice(index, 1);
    newFileInfos.splice(index, 1);
    setPreviews(newPreviews);
    setFileInfos(newFileInfos);
    onImagedelete && onImagedelete(null);
    
    // Notify parent that file info is cleared
    if (onFileInfoChange) {
      onFileInfoChange(null);
    }
    
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const formatFileSize = (size) => {
    if (!size) return "";
    return (size / 1024).toFixed(2) + " KB";
  };

  return (
    <div className="flex flex-col gap-1">
      <p
        
        className="mb-1 text-[#000000]"
      >
        {title}
      </p>

      {previews.length > 0 ? (
        <div className="space-y-2">
          {previews.map((preview, index) => (
            <div
              key={index}
              className="relative inline-block transition-transform duration-300 ease-in-out hover:scale-[1.02] border border-[#d7d5e2] shadow rounded-lg"
            >
              <img
                src={preview}
                alt="preview"
                className="h-[200px] w-[200px] object-cover rounded-lg"
              />
              <button
                onClick={() => handleDelete(index)}
                className="absolute right-1 bottom-1 bg-red-500 text-white rounded-full p-1 cursor-pointer"
              >
                <FaTimes className="h-3 w-3" />
              </button>
              {/* {fileInfos[index] && (
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white p-1 text-xs">
                  <div>{fileInfos[index].name}</div>
                  <div>{formatFileSize(fileInfos[index].size)}</div>
                </div>
              )} */}
            </div>
          ))}
        </div>
      ) : null}

      {(isMultiple || previews.length === 0) && (
        <div
          className={`w-[200px] h-[200px] border-2 border-dashed bg-white ${
            isDragging ? "border-blue-500" : "border-[#d7d5e2]"
          } cursor-pointer overflow-hidden`}
          onClick={handleClick}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            onChange={handleFileInputChange}
            className="hidden"
            multiple={isMultiple}
          />
          <div className="pt-1 pl-1 pr-3">
            Try dropping some files here, or click to select files to upload.
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageUpload;